"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amount = void 0;
const Units_1 = require("./Units");
class Amount {
    static ZERO = '0';
    static ONE_YOCTO = '1';
    constructor() { }
    static unitsToDecimals(units) {
        if (units === 'NEAR') {
            return 24;
        }
        if (units === 'USDT') {
            return 6;
        }
        if (units === 'USDC') {
            return 6;
        }
        if (units === 'BTC') {
            return 8;
        }
        if (units === 'ETH') {
            return 18;
        }
        return units;
    }
    /**
     * Parse from specific units and return a fixed string
     * @example
     * const rawAmount = Amount.parse('5', 'NEAR'); // '5000000000000000000000000'
     * @param amount human readable amount
     * @param units units
     */
    static parse(amount, units) {
        return Units_1.Units.parse(amount, Amount.unitsToDecimals(units)).toFixed(0);
    }
    /**
     * Format in specific units and return a fixed string
     * @example
     * const humanReadableAmount = Amount.format('5000000000000000000000000', 'NEAR'); // '5'
     * @param amount raw amount
     * @param units units
     * @param decimalPlaces decimal places
     */
    static format(amount, units, decimalPlaces) {
        amount = Units_1.Units.format(amount, Amount.unitsToDecimals(units));
        if (decimalPlaces) {
            return amount.toFixed(decimalPlaces);
        }
        else {
            return amount.toFixed();
        }
    }
}
exports.Amount = Amount;
//# sourceMappingURL=Amount.js.map